const localeId = "70af972e-5ed8-46a4-a9da-42819f6cf6dc";

export default localeId;
